import Link from "next/link";
import { Button } from "react-bootstrap";
import styles from "./CustomPlanCard.module.scss";

const CustomPlanCard = () => {
    return (
        <div className={`${styles.planOption}`}>
            <div className={styles.planNameContainer}>
                <h4 className={styles.planName}>Enterprise Plan</h4>
            </div>
            <p>
                We can customize a plan based on your needs - contact us below.
            </p>
            <Link href="/enterprise-subscription-contact">
                <Button className={styles.contactButton}>Contact Us</Button>
            </Link>
        </div>
    );
};

export default CustomPlanCard;
